/**
 * Claims Management Landing - tabbed layout for claim configuration pages.
 *
 * Tabs: Claim Schemas · Claim Workflows · Claim Mappings
 * Follows the Settings page pattern (Tab + Outlet).
 *
 * Note: This is the admin/config side (/manage/claims/*), not the
 * operational claims list at /claims.
 */

import { AppShell } from '@/admin/components/app-shell'
import { Tab } from '@/shared/components/ui/tab'
import { Outlet } from 'react-router'

const tabs = [
  { label: 'Claim Schemas', path: '/manage/claims/schemas' },
  { label: 'Claim Workflows', path: '/manage/claims/workflows' },
  { label: 'Claim Mappings', path: '/manage/claims/mappings' },
  { label: 'Registration', path: '/manage/claims/registration' },
]

export function ClaimsLandingPage() {
  return (
    <AppShell>
      <main className="page-container py-10">
        <div data-tour="claims-config">
          <h1 className="clara-title mb-6">Claims Configuration</h1>
          <Tab tabs={tabs} />
        </div>
        <Outlet />
      </main>
    </AppShell>
  )
}
